export default "__VITE_ASSET__0199751f__"